/**
 * Product events are always stamped with the authenticated session user.
 * Callers cannot supply another user's id.
 */
export function assertEventOwner(
  sessionUserId: string | null | undefined,
  requestedUserId: string | null | undefined
): boolean {
  return Boolean(sessionUserId && requestedUserId && sessionUserId === requestedUserId);
}

export function eventInsertPayload(
  sessionUserId: string,
  eventName: string,
  requestedUserId?: string
): { user_id: string; event_name: string } | null {
  const userId = requestedUserId ?? sessionUserId;
  if (!assertEventOwner(sessionUserId, userId)) return null;
  return { user_id: sessionUserId, event_name: eventName };
}
